import { createLazyComponent, LazyModule, LazyAction, LazyImport } from 'owa-bundling';

export { UserVoiceNpsProps } from './components/UserVoiceNps';
export {
    UserVoiceForumUrlFormat,
    consumerForumId,
    enterpriseForumId,
} from './utils/UserVoiceConstants';
export { UserVoiceInlineFeedbackTags } from './services/UserVoiceFeedbackTags';

export {
    UserVoiceFeedbackTags,
    TypeValues,
    Team1,
    UserVoiceFeedbackTxpTags,
    UserVoiceFeedbackSearchTags,
} from './services/UserVoiceFeedbackTags';
export { default as UserVoiceFeedbackType } from 'owa-service/lib/contract/UserVoiceFeedbackType';
export { SuggestionDialogOptions } from './actions/showUserVoiceSuggestionDialog';

export { userVoiceSuggestionStore } from 'owa-uservoice/lib/store/store';
export { NpsLogDataPointProps } from './services/sendNpsLogDatapoint';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "UserVoice" */ './lazyIndex'));

export let lazyLaunchInAppFeedback = new LazyAction(lazyModule, m => m.launchInAppFeedback);
export let lazyPostSuggestionAndSendLogDatapoint = new LazyImport(
    lazyModule,
    m => m.postSuggestionAndSendLogDatapoint
);
export let lazyShowUserVoiceSuggestionDialog = new LazyImport(
    lazyModule,
    m => m.showUserVoiceSuggestionDialog
);
export let UserVoiceNps = createLazyComponent(lazyModule, m => m.UserVoiceNps);
export { deactivateHelpCharmAction } from './actions/deactivateHelpCharmAction';
